import type { ComponentStyleConfig } from "@chakra-ui/theme";

const Heading: ComponentStyleConfig = {
  baseStyle: {
    color: "black",
    fontWeight: 800,
  }
};

export default Heading;